// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d31a177f","453":"7f709e95"}[chunkId] + ".chunk.js";
};